import * as StateLib from "@/Utils/StateLib";
import React, { Fragment, useState } from "react";
import { HorizontalToolbar, Divider, ToolIcon } from "@theorgchartdev/storybook";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { RenderToolbarContent } from "./ContextualToolbar";
import { GetToolbarStyle } from "./ContextualToolbar";
import ChartNavigationComposite from "@/appComponents/Navigation/ContextualToolbar/ChartNavigationComposite/ChartNavigationComposite";
import ChartBreadcrumbs from "@/appComponents/Navigation/ContextualToolbar/ChartBreadcrumbs/ChartBreadcrumbs";
import { getHoverTipContent } from "@/Utils/Misc";
import { Globals } from "@coreapp/CoreApp/Globals";
import { getFeatureAccess } from "@/Utils/Misc";
import { enumFeaturesList } from "@coreapp/constants";

const ContextualToolbarPlanning = () => {
  const wsMgrContext = useWSMgrContext();
  const wsMgr = wsMgrContext?.wsMgr.state;

  const [inPreviewMode, setPreviewMode] = useState(() => Globals._uiConfig.fShowOverlay);

  const showBreadCrumbs = getFeatureAccess(enumFeaturesList.breadcrumbs);

  const UpdatePreview = () => {
    setPreviewMode(!inPreviewMode);
    Globals._uiConfig.fShowOverlay = !inPreviewMode;
    wsMgr.ReloadCurrentSubChart();
    StateLib.ReRenderCanvas();
  };

  const leftContent = (
    <Fragment>
      <Fragment>
        <ChartNavigationComposite />
        <div className={"ocn-toolbar-horizontal-divider"}>
          <Divider vertical={true} />
        </div>
      </Fragment>
      {showBreadCrumbs && <ChartBreadcrumbs />}
    </Fragment>
  );

  const tooltipMessage = inPreviewMode ? "Hide plan overlay" : "Show plan overlay";

  const rightContent = (
    <Fragment>
      <ToolIcon
        data-testid={"ctx-toolbar-toggle-overlay"}
        name={inPreviewMode ? "eye" : "eye-slash"}
        className={
          inPreviewMode
            ? "ctx-toolbar-toggle-overlay-active"
            : "ctx-toolbar-toggle-overlay-inactive"
        }
        onClick={UpdatePreview}
        tooltipProps={getHoverTipContent(tooltipMessage)}
      />
    </Fragment>
  );

  return (
    <HorizontalToolbar
      style={GetToolbarStyle(true)}
      leftContent={RenderToolbarContent() ? leftContent : null}
      rightContent={rightContent}
    />
  );
};

export default ContextualToolbarPlanning;
